@if (isShown) {
    <div id="load-territories-control">
        <div class="leaflet-bar leaflet-control">
            <stButton
                btnClass="text-st-primary py-2"
                [btnLabel]="btnLabel"
                (onClick)="updateTerritories()"
                [title]="btnLabel"
            ></stButton>
        </div>
    </div>
}

@if (customControlTemplate) {
    <div id="custom-territory-control">
      <div [ngClass]="profileName" [innerHtml]="customControlTemplate"></div>
    </div>
}
